import { FILTERS_SPECS } from '../actionTypes';

const initialState = {
  preserveFilters: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FILTERS_SPECS.SET_FILTER_DATA:
      return {
        ...state,
        preserveFilters: action.payload,
      };
    default:
      return state;
  }
};
